/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA
// Component: lBLh7DX8FK3X

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGPresetMessage } from "@lg-plus/landing-components/LGPresetMessage"; // plasmic-import: LpMcJ1srr2E0/codeComponent
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: 3syvFCgGv-uE/component
import { LGCTAButton } from "@lg-plus/landing-components"; // plasmic-import: VjW0lAEokQG-/codeComponent
import SliderForm from "../../SliderForm"; // plasmic-import: PkxxjHWNrfMR/component
import Slider from "../../Slider"; // plasmic-import: xePllc52X9yw/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: BEFtbqk04VMi/component
import Zpusob from "../../Zpusob"; // plasmic-import: 7sfyMDRM7TU7/component
import { AntdAccordion } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { accordionHelpers as AntdAccordion_Helpers } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { AntdAccordionItem } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import Review from "../../Review"; // plasmic-import: 2C_W5wpe5krl/component
import Footer from "../../Footer"; // plasmic-import: OtHV2PiCSM_y/component
import { AntdSwitch } from "@plasmicpkgs/antd5/skinny/registerSwitch";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomepage.module.css"; // plasmic-import: lBLh7DX8FK3X/css

import LogoIcon from "./icons/PlasmicIcon__Logo"; // plasmic-import: VgZlJwPQnvW6/icon
import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: LQrPrtzaKPRe/icon
import ChevronDown2Icon from "./icons/PlasmicIcon__ChevronDown2"; // plasmic-import: R68VorKcSj0E/icon
import BurgerIcon from "./icons/PlasmicIcon__Burger"; // plasmic-import: i14F39DvtNKW/icon
import CrossIcon from "./icons/PlasmicIcon__Cross"; // plasmic-import: vq_kZtyW4NWX/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: 5QCLbTMH8s6r/icon
import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: FgVhhxnnM8Og/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: 9IFuAHqHnAAU/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: zaypHzTxqbsU/icon
import StarIcon from "./icons/PlasmicIcon__Star"; // plasmic-import: b2s6TWk264cF/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary" as const
    }
  };
}

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>("children");

export type PlasmicHomepage__OverridesType = {
  homepageWrapper?: Flex__<"div">;
  invalidLinkMessage?: Flex__<typeof LGPresetMessage>;
  header?: Flex__<"div">;
  navPanel?: Flex__<"div">;
  menu?: Flex__<"div">;
  menuBtn?: Flex__<"div">;
  menuCloseBtn?: Flex__<"div">;
  mainSection?: Flex__<"section">;
  sliderForm?: Flex__<typeof SliderForm>;
  slider?: Flex__<typeof Slider>;
  faqSection?: Flex__<"section">;
  faq?: Flex__<typeof AntdAccordion>;
  ul?: Flex__<"ul">;
  reviewsSection?: Flex__<"section">;
  reviews?: Flex__<typeof SliderWrapper>;
  staticReviewsSection?: Flex__<"section">;
  subfooter?: Flex__<"section">;
  sliderFormBottom?: Flex__<typeof SliderForm>;
  sliderBottom?: Flex__<typeof Slider>;
  footer?: Flex__<typeof Footer>;
  _switch?: Flex__<typeof AntdSwitch>;
  menuSwitch?: Flex__<typeof AntdSwitch>;
};

export interface DefaultHomepageProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "_switch.checked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "faq.activePanelId",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec(
          "activePanelId",
          AntdAccordion_Helpers
        )
      },
      {
        path: "reviews.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "reviews",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      },
      {
        path: "menuSwitch.checked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          hasVariant(globalVariants, "screen", "mobile") ? false : false
      },
      {
        path: "amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 17000
      },
      {
        path: "slider.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $state.amount
      },
      {
        path: "sliderBottom.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $state.amount
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head></Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"homepageWrapper"}
          data-plasmic-override={overrides.homepageWrapper}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_16oTSa7DQBPEWCKQEY9DXA",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.homepageWrapper
          )}
        >
          <LGPresetMessage
            data-plasmic-name={"invalidLinkMessage"}
            data-plasmic-override={overrides.invalidLinkMessage}
            className={classNames("__wab_instance", sty.invalidLinkMessage)}
            content={
              "Tento odkaz je neplatn\u00fd nebo jeho platnost vypr\u0161ela."
            }
            isDynamic={true}
            preset={"INVALID_LINK"}
          />

          <div
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("all", sty.header)}
          >
            <div
              data-plasmic-name={"navPanel"}
              data-plasmic-override={overrides.navPanel}
              className={classNames("all", sty.navPanel)}
            >
              <LogoIcon
                className={classNames("all", sty.svg___4Ms9I)}
                role={"img"}
              />
            </div>
            {(
              hasVariant(globalVariants, "screen", "mobile")
                ? (() => {
                    try {
                      return $state.menuSwitch.checked;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return true;
                      }
                      throw e;
                    }
                  })()
                : true
            ) ? (
              <div
                data-plasmic-name={"menu"}
                data-plasmic-override={overrides.menu}
                className={classNames("all", sty.menu)}
              >
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__16oTS",
                    "__wab_text",
                    sty.link___0GWfJ
                  )}
                  component={Link}
                  href={"#jaknato"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"Jak na to"}
                </PlasmicLink__>
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__16oTS",
                    "__wab_text",
                    sty.link___8Ugr
                  )}
                  component={Link}
                  href={"#faq"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"\u010cKO"}
                </PlasmicLink__>
                <PlasmicLink__
                  className={classNames(
                    "all",
                    "a",
                    "a__16oTS",
                    "__wab_text",
                    sty.link___7Qq0P
                  )}
                  component={Link}
                  href={"#review"}
                  legacyBehavior={false}
                  platform={"nextjs"}
                >
                  {"Recenze"}
                </PlasmicLink__>
                <ButtonPrimary
                  className={classNames(
                    "__wab_instance",
                    sty.buttonPrimary__looSh
                  )}
                  color={"neutral"}
                  label={
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__ilz0P
                      )}
                    >
                      {"Z\u00cdSKAT PEN\u00cdZE"}
                    </div>
                  }
                  onClick={async event => {
                    const $steps = {};

                    $steps["updateSwitchChecked"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["_switch", "checked"]
                            },
                            operation: 0,
                            value: true
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateSwitchChecked"] != null &&
                      typeof $steps["updateSwitchChecked"] === "object" &&
                      typeof $steps["updateSwitchChecked"].then === "function"
                    ) {
                      $steps["updateSwitchChecked"] =
                        await $steps["updateSwitchChecked"];
                    }
                  }}
                />

                <LGCTAButton
                  amount={$state.amount}
                  buttonSlot={
                    <ButtonPrimary
                      className={classNames(
                        "__wab_instance",
                        sty.buttonPrimary__i5PnW
                      )}
                      content={"Z\u00cdSKAT PEN\u00cdZE"}
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___7X6XV
                          )}
                        >
                          {"Z\u00cdSKAT PEN\u00cdZE"}
                        </div>
                      }
                    />
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.lgctaButton__h8LYj
                  )}
                  id={"cta-btn-2"}
                />
              </div>
            ) : null}
            {(
              hasVariant(globalVariants, "screen", "mobile")
                ? (() => {
                    try {
                      return !$state.menuSwitch.checked;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return true;
                      }
                      throw e;
                    }
                  })()
                : true
            ) ? (
              <div
                data-plasmic-name={"menuBtn"}
                data-plasmic-override={overrides.menuBtn}
                className={classNames("all", sty.menuBtn)}
              >
                <BurgerIcon
                  className={classNames("all", sty.svg__i3Ijc)}
                  onClick={async event => {
                    const $steps = {};

                    $steps["updateMenuSwitchChecked"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["menuSwitch", "checked"]
                            },
                            operation: 0,
                            value: true
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateMenuSwitchChecked"] != null &&
                      typeof $steps["updateMenuSwitchChecked"] === "object" &&
                      typeof $steps["updateMenuSwitchChecked"].then ===
                        "function"
                    ) {
                      $steps["updateMenuSwitchChecked"] =
                        await $steps["updateMenuSwitchChecked"];
                    }
                  }}
                  role={"img"}
                />
              </div>
            ) : null}
            {(
              hasVariant(globalVariants, "screen", "mobile")
                ? (() => {
                    try {
                      return $state.menuSwitch.checked;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return true;
                      }
                      throw e;
                    }
                  })()
                : true
            ) ? (
              <div
                data-plasmic-name={"menuCloseBtn"}
                data-plasmic-override={overrides.menuCloseBtn}
                className={classNames("all", sty.menuCloseBtn)}
              >
                <CrossIcon
                  className={classNames("all", sty.svg__gUblX)}
                  onClick={async event => {
                    const $steps = {};

                    $steps["updateMenuSwitchChecked"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["menuSwitch", "checked"]
                            },
                            operation: 0,
                            value: false
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateMenuSwitchChecked"] != null &&
                      typeof $steps["updateMenuSwitchChecked"] === "object" &&
                      typeof $steps["updateMenuSwitchChecked"].then ===
                        "function"
                    ) {
                      $steps["updateMenuSwitchChecked"] =
                        await $steps["updateMenuSwitchChecked"];
                    }
                  }}
                  role={"img"}
                />
              </div>
            ) : null}
          </div>
          <section
            data-plasmic-name={"mainSection"}
            data-plasmic-override={overrides.mainSection}
            className={classNames("all", sty.mainSection)}
          >
            <div className={classNames("all", "__wab_text", sty.text___7DTuw)}>
              {"\u2191"}
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__16oTS",
                "__wab_text",
                sty.h1___6Xhme
              )}
            >
              {"Nebankovn\u00ed p\u016fj\u010dka pro V\u00e1s"}
            </h1>
            <div className={classNames("all", sty.freeBox__tV1J)}>
              <div className={classNames("all", sty.freeBox__iWfmu)} />

              <div className={classNames("all", sty.freeBox__o6DoY)}>
                <SliderForm
                  data-plasmic-name={"sliderForm"}
                  data-plasmic-override={overrides.sliderForm}
                  className={classNames("__wab_instance", sty.sliderForm)}
                  slider={
                    <Slider
                      data-plasmic-name={"slider"}
                      data-plasmic-override={overrides.slider}
                      className={classNames("__wab_instance", sty.slider)}
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__rgyKj
                          )}
                        >
                          {"Chci si p\u016fj\u010dit"}
                        </div>
                      }
                      maxValue={30000}
                      minValue={1000}
                      onChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "slider",
                          "value"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }

                        (async val => {
                          const $steps = {};

                          $steps["updateAmount"] = true
                            ? (() => {
                                const actionArgs = {
                                  variable: {
                                    objRoot: $state,
                                    variablePath: ["amount"]
                                  },
                                  operation: 0,
                                  value: $state.slider.value
                                };
                                return (({
                                  variable,
                                  value,
                                  startIndex,
                                  deleteCount
                                }) => {
                                  if (!variable) {
                                    return;
                                  }
                                  const { objRoot, variablePath } = variable;

                                  $stateSet(objRoot, variablePath, value);
                                  return value;
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["updateAmount"] != null &&
                            typeof $steps["updateAmount"] === "object" &&
                            typeof $steps["updateAmount"].then === "function"
                          ) {
                            $steps["updateAmount"] =
                              await $steps["updateAmount"];
                          }
                        }).apply(null, eventArgs);
                      }}
                      step={1000}
                      value={generateStateValueProp($state, [
                        "slider",
                        "value"
                      ])}
                    />
                  }
                >
                  <LGCTAButton
                    amount={$state.amount}
                    buttonSlot={
                      <ButtonPrimary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonPrimary__jTl7B
                        )}
                        disabled={false}
                        label={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__cXqTv
                            )}
                          >
                            {"Z\u00cdSKAT PEN\u00cdZE"}
                          </div>
                        }
                      />
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.lgctaButton__hitxR
                    )}
                  />
                </SliderForm>
              </div>
            </div>
            <div className={classNames("all", sty.freeBox__qoeZ0)}>
              <div className={classNames("all", sty.freeBox__fFfb2)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__f7Yp)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: "/plasmic/creditstorm_landing_app/images/elWalletPng.png",
                    fullWidth: 161,
                    fullHeight: 125,
                    aspectRatio: undefined
                  }}
                />

                <div
                  className={classNames("all", "__wab_text", sty.text___0JjNw)}
                >
                  {"Do 5 minut v\u00edte,"}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text__vCe0J)}
                >
                  {"jestli p\u016fj\u010dku dostanete"}
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__mzCxc)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__xMmpR)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: "/plasmic/creditstorm_landing_app/images/elTimePng.png",
                    fullWidth: 160,
                    fullHeight: 133,
                    aspectRatio: undefined
                  }}
                />

                <div
                  className={classNames("all", "__wab_text", sty.text__ahurC)}
                >
                  {"Pen\u00edze na \u00fa\u010det"}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text___82Atq)}
                >
                  {"ihned po schv\u00e1len\u00ed"}
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__xqwn6)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__xmZd)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={{
                    src: "/plasmic/creditstorm_landing_app/images/elKcPng.png",
                    fullWidth: 161,
                    fullHeight: 125,
                    aspectRatio: undefined
                  }}
                />

                <div
                  className={classNames("all", "__wab_text", sty.text___5Xcn3)}
                >
                  {"Nejjednodu\u0161\u0161\u00ed \u017e\u00e1dost"}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text__qp2Hf)}
                >
                  {"o p\u016fj\u010dku jen u n\u00e1s"}
                </div>
              </div>
            </div>
            <h1
              className={classNames(
                "all",
                "h1",
                "h1__16oTS",
                "__wab_text",
                sty.h1__xwaS
              )}
              id={"jaknato"}
            >
              {
                "Jak\u00fdm zp\u016fsobem mohu po\u017e\u00e1dat o p\u016fj\u010dku?"
              }
            </h1>
            <div className={classNames("all", sty.freeBox__y6O3N)}>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__iVav)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__mkJhm)}
                  >
                    {"Po\u0161lete \u017e\u00e1dost"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__kcHs4)}
                  >
                    {
                      "Vypl\u0148te online formul\u00e1\u0159 na na\u0161em webu \u2014 je to jednoduch\u00e9 a rychl\u00e9"
                    }
                  </div>
                }
              />

              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__fCoIw)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__kpLne)}
                  >
                    {"P\u0159ipravte si doklady"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__hEwdb)}
                  >
                    {
                      "Kopii platn\u00e9ho ob\u010dansk\u00e9ho pr\u016fkazu, druh\u00fd doklad toto\u017enosti, V\u00fdpis z bankovn\u00edho \u00fa\u010dtu nebo v\u00fdplatn\u00ed p\u00e1sky za posledn\u00ed 3 m\u011bs\u00edce"
                    }
                  </div>
                }
              >
                {renderPlasmicSlot({
                  defaultContents: (
                    <Icon3Icon
                      className={classNames("all", sty.svg___2A9Gy)}
                      role={"img"}
                    />
                  ),

                  value: args.children
                })}
              </Zpusob>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__uu8Yd)}
                slot={
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___2MqGj
                    )}
                  >
                    {"Schv\u00e1len\u00ed \u017e\u00e1dosti"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__xHoR)}
                  >
                    {
                      "Va\u0161i \u017e\u00e1dost posoud\u00edme bez poplatku a d\u00e1me v\u00e1m v\u011bd\u011bt v\u00fdsledek"
                    }
                  </div>
                }
              >
                <Icon4Icon
                  className={classNames("all", sty.svg___8CQty)}
                  role={"img"}
                />
              </Zpusob>
              <Zpusob
                className={classNames("__wab_instance", sty.zpusob__vlnqn)}
                slot={
                  <div
                    className={classNames("all", "__wab_text", sty.text__wo5P8)}
                  >
                    {"Z\u00edskejte pen\u00edze"}
                  </div>
                }
                slot2={
                  <div
                    className={classNames("all", "__wab_text", sty.text__lfmIk)}
                  >
                    {
                      "Po schv\u00e1len\u00ed v\u00e1m p\u0159evedeme \u010d\u00e1stku od 1000 K\u010d do 30 000 K\u010d na v\u00e1\u0161 \u00fa\u010det"
                    }
                  </div>
                }
              >
                <Icon5Icon
                  className={classNames("all", sty.svg__mzLbV)}
                  role={"img"}
                />
              </Zpusob>
            </div>
          </section>
          <section
            data-plasmic-name={"faqSection"}
            data-plasmic-override={overrides.faqSection}
            className={classNames("all", sty.faqSection)}
          >
            <h3
              className={classNames(
                "all",
                "h3",
                "h3__16oTS",
                "__wab_text",
                sty.h3___2XCMl
              )}
              id={"faq"}
            >
              {
                "Nej\u010dast\u011bji kladen\u00e9 dotazy\nohledn\u011b p\u016fj\u010dek"
              }
            </h3>
            {(() => {
              const child$Props = {
                activeKey: generateStateValueProp($state, [
                  "faq",
                  "activePanelId"
                ]),
                bordered: false,
                className: classNames("__wab_instance", sty.faq),
                expandIconPosition: "end",
                items: (
                  <React.Fragment>
                    <AntdAccordionItem
                      className={classNames(
                        "__wab_instance",
                        sty.accordionItem__l72D
                      )}
                      id={1}
                      label2={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___1EOh5
                          )}
                        >
                          {"Mohu si p\u016fj\u010dit na cokoliv?"}
                        </div>
                      }
                      showArrow={true}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__nsIDw
                        )}
                      >
                        {
                          "Ano, m\u016f\u017eete si p\u016fj\u010dit na cokoliv, co pot\u0159ebujete. Nezkoum\u00e1me \u00fa\u010del va\u0161\u00ed p\u016fj\u010dky, a proto nen\u00ed nutn\u00e9 n\u00e1m nic dokl\u00e1dat. Pen\u00edze m\u016f\u017eete vyu\u017e\u00edt nap\u0159\u00edklad na rekonstrukci bydlen\u00ed, koupi automobilu, financov\u00e1n\u00ed dovolen\u00e9, n\u00e1kup elektroniky, vzd\u011bl\u00e1n\u00ed nebo dokonce na konsolidaci st\u00e1vaj\u00edc\u00edch dluh\u016f. Rozhodnut\u00ed je jen na v\u00e1s."
                        }
                      </div>
                    </AntdAccordionItem>
                    <AntdAccordionItem
                      className={classNames(
                        "__wab_instance",
                        sty.accordionItem___7IqRo
                      )}
                      id={2}
                      label2={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__wKs9L
                          )}
                        >
                          {
                            "Co mus\u00edm spl\u0148ovat pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky?"
                          }
                        </div>
                      }
                      showArrow={true}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__bhDuz
                        )}
                      >
                        {
                          "Pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky je nutn\u00e9 splnit n\u011bkolik z\u00e1kladn\u00edch podm\u00ednek. Tato p\u016fj\u010dka je ur\u010dena ob\u010dan\u016fm s trval\u00fdm pobytem na \u00fazem\u00ed \u010cesk\u00e9 republiky, kte\u0159\u00ed maj\u00ed pravideln\u00fd p\u0159\u00edjem a vlastn\u00ed bankovn\u00ed \u00fa\u010det, na kter\u00fd budou finance vyplaceny. D\u016fle\u017eit\u00e9 je tak\u00e9 spl\u0148ovat v\u011bkovou hranici, kter\u00e1 je stanovena na 18 a\u017e 75 let. Krom\u011b t\u011bchto podm\u00ednek je pot\u0159eba m\u00edt schopnost \u0159\u00e1dn\u011b spl\u00e1cet p\u016fj\u010dku dle sjednan\u00fdch podm\u00ednek."
                        }
                      </div>
                    </AntdAccordionItem>
                    <AntdAccordionItem
                      className={classNames(
                        "__wab_instance",
                        sty.accordionItem__i0CSn
                      )}
                      id={"3"}
                      label2={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__cE5Jh
                          )}
                        >
                          {
                            "Jsou s\u202fvy\u0159\u00edzen\u00edm p\u016fj\u010dky spojeny n\u011bjak\u00e9 poplatky?"
                          }
                        </div>
                      }
                      showArrow={true}
                    >
                      {
                        "Ne, za schv\u00e1len\u00ed p\u016fj\u010dky se neplat\u00ed \u017e\u00e1dn\u00e9 poplatky. U n\u00e1s ne\u00fa\u010dtujeme \u017e\u00e1dn\u00e9 skryt\u00e9 n\u00e1klady za samotn\u00e9 pod\u00e1n\u00ed \u017e\u00e1dosti nebo proces schv\u00e1len\u00ed. M\u016f\u017eete si b\u00fdt jisti, \u017ee cel\u00fd proces je transparentn\u00ed a v\u0161echny podm\u00ednky jsou p\u0159edem jasn\u011b stanoven\u00e9. Poplatky, pokud n\u011bjak\u00e9 existuj\u00ed, se mohou vztahovat pouze na veden\u00ed \u00fav\u011bru, p\u0159\u00edpadn\u00e9 prodlou\u017een\u00ed splatnosti nebo jin\u00e9 slu\u017eby, kter\u00e9 si dobrovoln\u011b zvol\u00edte. Tyto poplatky jsou v\u017edy uvedeny ve smlouv\u011b, abyste m\u011bli p\u0159esn\u00fd p\u0159ehled o v\u0161ech n\u00e1kladech spojen\u00fdch s va\u0161\u00ed p\u016fj\u010dkou."
                      }
                    </AntdAccordionItem>
                    <AntdAccordionItem
                      className={classNames(
                        "__wab_instance",
                        sty.accordionItem__e8Qw
                      )}
                      id={"5"}
                      label2={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__uz8P6
                          )}
                        >
                          {
                            "Jak\u00e9 doklady mus\u00edm p\u0159edlo\u017eit, abych z\u00edskal/a p\u016fj\u010dku?"
                          }
                        </div>
                      }
                      showArrow={true}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__ixOb
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {
                              "Pro schv\u00e1len\u00ed p\u016fj\u010dky je v\u017edy nutn\u00e9 dolo\u017eit n\u011bkolik z\u00e1kladn\u00edch dokument\u016f, kter\u00e9 slou\u017e\u00ed k ov\u011b\u0159en\u00ed va\u0161\u00ed toto\u017enosti a finan\u010dn\u00ed situace. Pat\u0159\u00ed mezi n\u011b:\n\n"
                            }
                          </React.Fragment>
                          {
                            <ul
                              data-plasmic-name={"ul"}
                              data-plasmic-override={overrides.ul}
                              className={classNames(
                                "all",
                                "ul",
                                "ul__16oTS",
                                sty.ul
                              )}
                            >
                              <li
                                className={classNames(
                                  "all",
                                  "li",
                                  "li__16oTS",
                                  "__wab_text",
                                  sty.li__rfgK
                                )}
                              >
                                {
                                  "Kopie platn\u00e9ho ob\u010dansk\u00e9ho pr\u016fkazu."
                                }
                              </li>
                              <li
                                className={classNames(
                                  "all",
                                  "li",
                                  "li__16oTS",
                                  "__wab_text",
                                  sty.li__qZgQl
                                )}
                              >
                                {
                                  "Kopie druh\u00e9ho dokladu toto\u017enosti (nap\u0159. \u0159idi\u010dsk\u00fd pr\u016fkaz, cestovn\u00ed pas nebo rodn\u00fd list)."
                                }
                              </li>
                              <li
                                className={classNames(
                                  "all",
                                  "li",
                                  "li__16oTS",
                                  "__wab_text",
                                  sty.li__wuvB2
                                )}
                              >
                                {
                                  "V\u00fdplatn\u00ed p\u00e1sky za posledn\u00ed 3 m\u011bs\u00edce nebo v\u00fdpisy z bankovn\u00edho \u00fa\u010dtu za posledn\u00ed 3 m\u011bs\u00edce, kter\u00e9 prokazuj\u00ed v\u00e1\u0161 pravideln\u00fd p\u0159\u00edjem."
                                }
                              </li>
                            </ul>
                          }
                          <React.Fragment>
                            {
                              "\nKrom\u011b t\u011bchto dokument\u016f m\u016f\u017ee b\u00fdt v n\u011bkter\u00fdch p\u0159\u00edpadech poskytovatelem p\u016fj\u010dky vy\u017eadov\u00e1no tak\u00e9 potvrzen\u00ed o trval\u00e9m pobytu nebo doklad o vlastnictv\u00ed bankovn\u00edho \u00fa\u010dtu, na kter\u00fd budou pen\u00edze vyplaceny. D\u016fle\u017eit\u00e9 je, aby v\u0161echny dokumenty byly aktu\u00e1ln\u00ed, co\u017e urychl\u00ed proces schv\u00e1len\u00ed va\u0161\u00ed p\u016fj\u010dky. "
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </div>
                    </AntdAccordionItem>
                    <AntdAccordionItem
                      className={classNames(
                        "__wab_instance",
                        sty.accordionItem__k8PmR
                      )}
                      id={"6"}
                      label2={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__huZf0
                          )}
                        >
                          {
                            "Dostanu p\u016fj\u010dku p\u0159\u00edmo od va\u0161\u00ed spole\u010dnosti?"
                          }
                        </div>
                      }
                      showArrow={true}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__yGUg1
                        )}
                      >
                        {
                          "Na\u0161e spole\u010dnost vystupuje jako zprost\u0159edkovatel mezi v\u00e1mi a \u00fav\u011brov\u00fdmi spole\u010dnostmi, kter\u00e9 v\u00e1m mohou p\u016fj\u010dku poskytnout. Po vypln\u011bn\u00ed \u017e\u00e1dosti ode\u0161leme v\u00e1\u0161 po\u017eadavek n\u011bkolika \u00fav\u011brov\u00fdm spole\u010dnostem a po obdr\u017een\u00ed odpov\u011bd\u00ed v\u00e1s nasm\u011brujeme na tu spole\u010dnost, kter\u00e1 m\u00e1 nejv\u011bt\u0161\u00ed pravd\u011bpodobnost v\u00e1m p\u016fj\u010dku skute\u010dn\u011b schv\u00e1lit."
                        }
                      </div>
                    </AntdAccordionItem>
                  </React.Fragment>
                ),
                onChange: async (...eventArgs: any) => {
                  generateStateOnChangePropForCodeComponents(
                    $state,
                    "activePanelId",
                    ["faq", "activePanelId"],
                    AntdAccordion_Helpers
                  ).apply(null, eventArgs);
                },
                rotationAngle: 90
              };
              initializeCodeComponentStates(
                $state,
                [
                  {
                    name: "activePanelId",
                    plasmicStateName: "faq.activePanelId"
                  }
                ],
                [],
                AntdAccordion_Helpers ?? {},
                child$Props
              );

              return (
                <AntdAccordion
                  data-plasmic-name={"faq"}
                  data-plasmic-override={overrides.faq}
                  {...child$Props}
                />
              );
            })()}
          </section>
          <section
            data-plasmic-name={"reviewsSection"}
            data-plasmic-override={overrides.reviewsSection}
            className={classNames("all", sty.reviewsSection)}
          >
            <h3
              className={classNames(
                "all",
                "h3",
                "h3__16oTS",
                "__wab_text",
                sty.h3__aHazv
              )}
            >
              {"Co \u0159\u00edkaj\u00ed na\u0161i klienti"}
            </h3>
            {(() => {
              const child$Props = {
                arrows: true,
                autoplay: false,
                autoplaySpeed: 0,
                beforeChange: async (...eventArgs: any) => {
                  generateStateOnChangePropForCodeComponents(
                    $state,
                    "currentSlide",
                    ["reviews", "currentSlide"],
                    SliderWrapper_Helpers
                  ).apply(null, eventArgs);
                },
                centerMode: true,
                className: classNames("__wab_instance", sty.reviews),
                cssEase: "linear",
                dots: true,
                initialSlide: generateStateValueProp($state, [
                  "reviews",
                  "currentSlide"
                ]),
                ref: ref => {
                  $refs["reviews"] = ref;
                },
                sliderScopeClassName: sty["reviews__slider"],
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: 500,
                variableWidth: false
              };
              initializeCodeComponentStates(
                $state,
                [
                  {
                    name: "currentSlide",
                    plasmicStateName: "reviews.currentSlide"
                  }
                ],
                [],
                SliderWrapper_Helpers ?? {},
                child$Props
              );

              return (
                <SliderWrapper
                  data-plasmic-name={"reviews"}
                  data-plasmic-override={overrides.reviews}
                  {...child$Props}
                >
                  <div className={classNames("all", sty.freeBox__y3NNb)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__gFg8C
                      )}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__qeCbt)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/romanPng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text___9C1R
                        )}
                      >
                        {
                          "Nem\u00e1m vysok\u00fd p\u0159\u00edjem, tak\u017ee jsem ne\u010dekal, \u017ee mi n\u011bkdo p\u016fj\u010d\u00ed. Ale tady mi to fakt na\u0161lo nab\u00eddku, kterou jsem mohl v pohod\u011b zvl\u00e1dnout. V\u0161echno online, bez zbyte\u010dn\u00e9ho b\u011bh\u00e1n\u00ed a vysv\u011btlov\u00e1n\u00ed. D\u00edk!"
                        }
                      </div>
                    </Review>
                  </div>
                  <div className={classNames("all", sty.freeBox__thrX)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__nqoRd
                      )}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img___8WwIj)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/luciePng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      slot2={"Lucie H., 26 let"}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text___9Ibu8
                        )}
                      >
                        {
                          "Rozbila se mi lednice a pot\u0159ebovala jsem rychle pen\u00edze na novou. Necht\u011bla jsem ob\u00edhat banky, tak jsem to zkusila tady. Sta\u010dilo zadat \u010d\u00e1stku a syst\u00e9m mi hned nab\u00eddl p\u016fj\u010dku na m\u00edru. Do p\u016fl hodiny jsem m\u011bla pen\u00edze na \u00fa\u010dtu."
                        }
                      </div>
                    </Review>
                  </div>
                  <div className={classNames("all", sty.freeBox__wWlXa)}>
                    <Review
                      className={classNames("__wab_instance", sty.review__pJRs)}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__pe6P)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/tomasPng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      slot2={"Tom\u00e1\u0161 V., 59 let"}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__eYosL
                        )}
                      >
                        {
                          "Tahle slu\u017eba mi u\u0161et\u0159ila spoustu \u010dasu i nerv\u016f. M\u00edsto pro\u010d\u00edt\u00e1n\u00ed des\u00edtek nab\u00eddek mi sta\u010dilo p\u00e1r kliknut\u00ed a m\u011bl jsem jasno. Rozhodn\u011b doporu\u010duju ka\u017ed\u00e9mu, kdo nechce riskovat."
                        }
                      </div>
                    </Review>
                  </div>
                  <div className={classNames("all", sty.freeBox__hiRu)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__giQdv
                      )}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__y3Jt1)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/monikaPng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      slot2={"Monika K., 33 let"}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__qpKgx
                        )}
                      >
                        {
                          "Jsem na mate\u0159sk\u00e9 a hledala jsem p\u016fj\u010dku, ale v\u011bt\u0161ina firem m\u011b hned odm\u00edtla. Tady mi to rovnou vybralo poskytovatele, kter\u00fd bere ohled i na moji situaci. Bez poni\u017euj\u00edc\u00edch dotaz\u016f a \u010dek\u00e1n\u00ed. Moc mi to pomohlo."
                        }
                      </div>
                    </Review>
                  </div>
                  <div className={classNames("all", sty.freeBox__rQ32U)}>
                    <Review
                      className={classNames("__wab_instance", sty.review__zlLD)}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__le4Uz)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/petraPng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      slot2={"Petra N., 56 let"}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__jEg34
                        )}
                      >
                        {
                          "L\u00edbilo se mi, \u017ee mi slu\u017eba rovnou nab\u00eddla nejvhodn\u011bj\u0161\u00ed \u0159e\u0161en\u00ed, bez zbyte\u010dn\u00e9ho pap\u00edrov\u00e1n\u00ed a otravn\u00fdch telefon\u00e1t\u016f. Pen\u00edze jsem m\u011bla na \u00fa\u010dtu je\u0161t\u011b ten sam\u00fd den."
                        }
                      </div>
                    </Review>
                  </div>
                  <div className={classNames("all", sty.freeBox__ziUpu)}>
                    <Review
                      className={classNames(
                        "__wab_instance",
                        sty.review__jYsdj
                      )}
                      slot={
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__sb6CW)}
                          displayHeight={"40px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"40px"}
                          loading={"lazy"}
                          src={{
                            src: "/plasmic/creditstorm_landing_app/images/martinPng.png",
                            fullWidth: 300,
                            fullHeight: 300,
                            aspectRatio: undefined
                          }}
                        />
                      }
                      slot2={"Martin B., 35 let"}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__dAVz
                        )}
                      >
                        {
                          "Pot\u0159eboval jsem rychle zaplatit opravu auta. Necht\u011bl jsem nic slo\u017eit\u011b \u0159e\u0161it, tak jsem to zkusil tady. Vyplnil jsem \u010d\u00e1stku, syst\u00e9m mi hned na\u0161el nab\u00eddku a pen\u00edze jsem m\u011bl na \u00fa\u010dtu ten sam\u00fd den. Fakt pohoda."
                        }
                      </div>
                    </Review>
                  </div>
                </SliderWrapper>
              );
            })()}
          </section>
          <section
            data-plasmic-name={"staticReviewsSection"}
            data-plasmic-override={overrides.staticReviewsSection}
            className={classNames("all", sty.staticReviewsSection)}
          >
            <h3
              className={classNames(
                "all",
                "h3",
                "h3__16oTS",
                "__wab_text",
                sty.h3__k2NRi
              )}
              id={"review"}
            >
              {"Co \u0159\u00edkaj\u00ed na\u0161i klienti"}
            </h3>
            <div className={classNames("all", sty.freeBox__xfMry)}>
              <div className={classNames("all", sty.freeBox__kfJiG)}>
                <Review
                  className={classNames("__wab_instance", sty.review__iz9J)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__y7KM8)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/romanPng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__eyN3F)}
                  >
                    {
                      "Nem\u00e1m vysok\u00fd p\u0159\u00edjem, tak\u017ee jsem ne\u010dekal, \u017ee mi n\u011bkdo p\u016fj\u010d\u00ed. Ale tady mi to fakt na\u0161lo nab\u00eddku, kterou jsem mohl v pohod\u011b zvl\u00e1dnout. V\u0161echno online, bez zbyte\u010dn\u00e9ho b\u011bh\u00e1n\u00ed a vysv\u011btlov\u00e1n\u00ed. D\u00edk!"
                    }
                  </div>
                </Review>
              </div>
              <div className={classNames("all", sty.freeBox__x02Vj)}>
                <Review
                  className={classNames("__wab_instance", sty.review__xB9Eg)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__j0Nhl)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/luciePng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  slot2={"Lucie H., 26 let"}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__lVy3)}
                  >
                    {
                      "Rozbila se mi lednice a pot\u0159ebovala jsem rychle pen\u00edze na novou. Necht\u011bla jsem ob\u00edhat banky, tak jsem to zkusila tady. Sta\u010dilo zadat \u010d\u00e1stku a syst\u00e9m mi hned nab\u00eddl p\u016fj\u010dku na m\u00edru. Do p\u016fl hodiny jsem m\u011bla pen\u00edze na \u00fa\u010dtu."
                    }
                  </div>
                </Review>
              </div>
              <div className={classNames("all", sty.freeBox__nr4Pl)}>
                <Review
                  className={classNames("__wab_instance", sty.review__a74DG)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__rQ9A8)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/tomasPng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  slot2={"Tom\u00e1\u0161 V., 59 let"}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__v4NTq)}
                  >
                    {
                      "Tahle slu\u017eba mi u\u0161et\u0159ila spoustu \u010dasu i nerv\u016f. M\u00edsto pro\u010d\u00edt\u00e1n\u00ed des\u00edtek nab\u00eddek mi sta\u010dilo p\u00e1r kliknut\u00ed a m\u011bl jsem jasno. Rozhodn\u011b doporu\u010duju ka\u017ed\u00e9mu, kdo nechce riskovat."
                    }
                  </div>
                </Review>
              </div>
              <div className={classNames("all", sty.freeBox__nanFh)}>
                <Review
                  className={classNames("__wab_instance", sty.review___9Hpv8)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__gfpYf)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/monikaPng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  slot2={"Monika K., 33 let"}
                >
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___18Oz8
                    )}
                  >
                    {
                      "Jsem na mate\u0159sk\u00e9 a hledala jsem p\u016fj\u010dku, ale v\u011bt\u0161ina firem m\u011b hned odm\u00edtla. Tady mi to rovnou vybralo poskytovatele, kter\u00fd bere ohled i na moji situaci. Bez poni\u017euj\u00edc\u00edch dotaz\u016f a \u010dek\u00e1n\u00ed. Moc mi to pomohlo."
                    }
                  </div>
                </Review>
              </div>
              <div className={classNames("all", sty.freeBox__ww5Ub)}>
                <Review
                  className={classNames("__wab_instance", sty.review__uYlAn)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__yjNyM)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/petraPng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  slot2={"Petra N., 56 let"}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__oaVqq)}
                  >
                    {
                      "L\u00edbilo se mi, \u017ee mi slu\u017eba rovnou nab\u00eddla nejvhodn\u011bj\u0161\u00ed \u0159e\u0161en\u00ed, bez zbyte\u010dn\u00e9ho pap\u00edrov\u00e1n\u00ed a otravn\u00fdch telefon\u00e1t\u016f. Pen\u00edze jsem m\u011bla na \u00fa\u010dtu je\u0161t\u011b ten sam\u00fd den."
                    }
                  </div>
                </Review>
              </div>
              <div className={classNames("all", sty.freeBox___1Y4Yl)}>
                <Review
                  className={classNames("__wab_instance", sty.review__g9DhB)}
                  slot={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__gyT8P)}
                      displayHeight={"40px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"40px"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/creditstorm_landing_app/images/martinPng.png",
                        fullWidth: 300,
                        fullHeight: 300,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  slot2={"Martin B., 35 let"}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__dRbV)}
                  >
                    {
                      "Pot\u0159eboval jsem rychle zaplatit opravu auta. Necht\u011bl jsem nic slo\u017eit\u011b \u0159e\u0161it, tak jsem to zkusil tady. Vyplnil jsem \u010d\u00e1stku, syst\u00e9m mi hned na\u0161el nab\u00eddku a pen\u00edze jsem m\u011bl na \u00fa\u010dtu ten sam\u00fd den. Fakt pohoda."
                    }
                  </div>
                </Review>
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"subfooter"}
            data-plasmic-override={overrides.subfooter}
            className={classNames("all", sty.subfooter)}
          >
            <div className={classNames("all", sty.freeBox__jht4O)}>
              <div className={classNames("all", sty.freeBox__tWuNq)}>
                <h3
                  className={classNames(
                    "all",
                    "h3",
                    "h3__16oTS",
                    "__wab_text",
                    sty.h3__bcWx9
                  )}
                >
                  {"Registrace"}
                </h3>
                <div
                  className={classNames("all", "__wab_text", sty.text__kBfll)}
                >
                  {
                    "Je\u0161t\u011b se nezn\u00e1me, a proto od v\u00e1s pot\u0159ebujeme p\u00e1r \u00fadaj\u016f, abychom v\u00e1m mohli p\u016fj\u010dit pen\u00edze."
                  }
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__kl3C)}>
                <SliderForm
                  data-plasmic-name={"sliderFormBottom"}
                  data-plasmic-override={overrides.sliderFormBottom}
                  className={classNames("__wab_instance", sty.sliderFormBottom)}
                  slider={
                    <Slider
                      data-plasmic-name={"sliderBottom"}
                      data-plasmic-override={overrides.sliderBottom}
                      className={classNames("__wab_instance", sty.sliderBottom)}
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__vxuO5
                          )}
                        >
                          {"Chci si p\u016fj\u010dit"}
                        </div>
                      }
                      maxValue={30000}
                      minValue={1000}
                      onChange={async (...eventArgs: any) => {
                        generateStateOnChangeProp($state, [
                          "sliderBottom",
                          "value"
                        ]).apply(null, eventArgs);

                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }

                        (async val => {
                          const $steps = {};

                          $steps["updateAmount"] = true
                            ? (() => {
                                const actionArgs = {
                                  variable: {
                                    objRoot: $state,
                                    variablePath: ["amount"]
                                  },
                                  operation: 0,
                                  value: $state.sliderBottom.value
                                };
                                return (({
                                  variable,
                                  value,
                                  startIndex,
                                  deleteCount
                                }) => {
                                  if (!variable) {
                                    return;
                                  }
                                  const { objRoot, variablePath } = variable;

                                  $stateSet(objRoot, variablePath, value);
                                  return value;
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["updateAmount"] != null &&
                            typeof $steps["updateAmount"] === "object" &&
                            typeof $steps["updateAmount"].then === "function"
                          ) {
                            $steps["updateAmount"] =
                              await $steps["updateAmount"];
                          }
                        }).apply(null, eventArgs);
                      }}
                      step={1000}
                      value={generateStateValueProp($state, [
                        "sliderBottom",
                        "value"
                      ])}
                    />
                  }
                >
                  <LGCTAButton
                    amount={$state.amount}
                    buttonSlot={
                      <ButtonPrimary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonPrimary___0QsYo
                        )}
                        label={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text___00UuM
                            )}
                          >
                            {"Z\u00cdSKAT PEN\u00cdZE"}
                          </div>
                        }
                      />
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.lgctaButton__xD96C
                    )}
                    id={"cta-btn-3"}
                  />
                </SliderForm>
              </div>
            </div>
          </section>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer, {
              [sty.footerglobal_tmp_override]: hasVariant(
                globalVariants,
                "tmp",
                "override"
              )
            })}
          />

          <AntdSwitch
            data-plasmic-name={"_switch"}
            data-plasmic-override={overrides._switch}
            checked={generateStateValueProp($state, ["_switch", "checked"])}
            className={classNames("__wab_instance", sty._switch)}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["_switch", "checked"]).apply(
                null,
                eventArgs
              );
            }}
          />

          <AntdSwitch
            data-plasmic-name={"menuSwitch"}
            data-plasmic-override={overrides.menuSwitch}
            checked={generateStateValueProp($state, ["menuSwitch", "checked"])}
            className={classNames("__wab_instance", sty.menuSwitch)}
            defaultChecked={
              hasVariant(globalVariants, "screen", "mobile") ? false : false
            }
            disabled={false}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "menuSwitch",
                "checked"
              ]).apply(null, eventArgs);

              (async checked => {
                const $steps = {};

                $steps["updateSwitchChecked"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["_switch", "checked"]
                        },
                        operation: 0
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;

                        $stateSet(objRoot, variablePath, value);
                        return value;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateSwitchChecked"] != null &&
                  typeof $steps["updateSwitchChecked"] === "object" &&
                  typeof $steps["updateSwitchChecked"].then === "function"
                ) {
                  $steps["updateSwitchChecked"] =
                    await $steps["updateSwitchChecked"];
                }
              }).apply(null, eventArgs);
            }}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  homepageWrapper: [
    "homepageWrapper",
    "invalidLinkMessage",
    "header",
    "navPanel",
    "menu",
    "menuBtn",
    "menuCloseBtn",
    "mainSection",
    "sliderForm",
    "slider",
    "faqSection",
    "faq",
    "ul",
    "reviewsSection",
    "reviews",
    "staticReviewsSection",
    "subfooter",
    "sliderFormBottom",
    "sliderBottom",
    "footer",
    "_switch",
    "menuSwitch"
  ],
  invalidLinkMessage: ["invalidLinkMessage"],
  header: ["header", "navPanel", "menu", "menuBtn", "menuCloseBtn"],
  navPanel: ["navPanel"],
  menu: ["menu"],
  menuBtn: ["menuBtn"],
  menuCloseBtn: ["menuCloseBtn"],
  mainSection: ["mainSection", "sliderForm", "slider"],
  sliderForm: ["sliderForm", "slider"],
  slider: ["slider"],
  faqSection: ["faqSection", "faq", "ul"],
  faq: ["faq", "ul"],
  ul: ["ul"],
  reviewsSection: ["reviewsSection", "reviews"],
  reviews: ["reviews"],
  staticReviewsSection: ["staticReviewsSection"],
  subfooter: ["subfooter", "sliderFormBottom", "sliderBottom"],
  sliderFormBottom: ["sliderFormBottom", "sliderBottom"],
  sliderBottom: ["sliderBottom"],
  footer: ["footer"],
  _switch: ["_switch"],
  menuSwitch: ["menuSwitch"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  homepageWrapper: "div";
  invalidLinkMessage: typeof LGPresetMessage;
  header: "div";
  navPanel: "div";
  menu: "div";
  menuBtn: "div";
  menuCloseBtn: "div";
  mainSection: "section";
  sliderForm: typeof SliderForm;
  slider: typeof Slider;
  faqSection: "section";
  faq: typeof AntdAccordion;
  ul: "ul";
  reviewsSection: "section";
  reviews: typeof SliderWrapper;
  staticReviewsSection: "section";
  subfooter: "section";
  sliderFormBottom: typeof SliderForm;
  sliderBottom: typeof Slider;
  footer: typeof Footer;
  _switch: typeof AntdSwitch;
  menuSwitch: typeof AntdSwitch;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "homepageWrapper") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("homepageWrapper"),
  {
    // Helper components rendering sub-elements
    invalidLinkMessage: makeNodeComponent("invalidLinkMessage"),
    header: makeNodeComponent("header"),
    navPanel: makeNodeComponent("navPanel"),
    menu: makeNodeComponent("menu"),
    menuBtn: makeNodeComponent("menuBtn"),
    menuCloseBtn: makeNodeComponent("menuCloseBtn"),
    mainSection: makeNodeComponent("mainSection"),
    sliderForm: makeNodeComponent("sliderForm"),
    slider: makeNodeComponent("slider"),
    faqSection: makeNodeComponent("faqSection"),
    faq: makeNodeComponent("faq"),
    ul: makeNodeComponent("ul"),
    reviewsSection: makeNodeComponent("reviewsSection"),
    reviews: makeNodeComponent("reviews"),
    staticReviewsSection: makeNodeComponent("staticReviewsSection"),
    subfooter: makeNodeComponent("subfooter"),
    sliderFormBottom: makeNodeComponent("sliderFormBottom"),
    sliderBottom: makeNodeComponent("sliderBottom"),
    footer: makeNodeComponent("footer"),
    _switch: makeNodeComponent("_switch"),
    menuSwitch: makeNodeComponent("menuSwitch"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
